import {
    ACTION_GET_RESULTS_MONTHLY_CHART,
    ACTION_GET_RESULTS_WEEKLY_CHART,
    ACTION_GET_RESULTS_ANNUAL_CHART,
    ACTION_GET_RESULTS_HAPPINESS,
    SET_RESULTS_MONTHLY_CHART,
    SET_RESULTS_ANNUAL_CHART,
    SET_RESULTS_WEEKLY_CHART,
    SET_RESULTS_HAPPINESS
} from "@/views/chart/store/types/types.js";

import { HapinessService } from "../../../services";

const actions = {

    [ACTION_GET_RESULTS_HAPPINESS]: ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            state.loading = true;

            const idGroup = sessionStorage.getItem("idGroup");
            const idEmpresa = sessionStorage.getItem("idEmpresa");
            const idUsuario = sessionStorage.getItem("idUsuario");

            HapinessService.getResultsHappiness( idGroup, idEmpresa, idUsuario )
            .then(async resp => {                    
                commit(SET_RESULTS_HAPPINESS, resp.data.payload);
                resolve(resp.data.payload)
            })
            .catch(err => {
                reject(err)
            })
            .finally(() => state.loading = false);
        })
    },

        
    [ACTION_GET_RESULTS_WEEKLY_CHART]: ({ state, commit } ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                HapinessService.getResultsWeeklyChart(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_RESULTS_WEEKLY_CHART, resp.data.payload.windows);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_RESULTS_MONTHLY_CHART]: ({ state, commit } ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                HapinessService.getResultsMonthlyChart(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_RESULTS_MONTHLY_CHART, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },

    [ACTION_GET_RESULTS_ANNUAL_CHART]: ({ state, commit } ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                HapinessService.getResultsAnnualChart(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_RESULTS_ANNUAL_CHART, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error("Error en la solicitud:", error);
                reject(error);
            }
        });
    },
}

export default actions;